//block all symbols except double quote (")
export const regexAllLanguagesExceptDoubleQuote =
  /^[^~`!@#$%^&*()+=\[\]{}|\\:;'<>,.?/€£¥•]*$/;

export const ADD_OBJECT_TO_GROUP_VALIDATION =
  'Only non-URL social profiles and keywords/hashtags can be added for now, as objects are still being processed. Please remove any objects with URLs.';

export const initialValueContentCustomReport = {
  contentTypeList: null,
  excludeKeywords: null,
  retweetFilter: 'all',
  talkType: null,
  ageGeneration: null,
  fromUsername: null,
  includeKeywords: null,
  metric: null,
  category: null,
  objectGroupId: null,
  objectList: null,
  postOwnership: null,
  retweetFromOriginalIds: [],
  sentiment: null,
  sentimentConfidenceLevelMax: 1,
  sentimentConfidenceLevelMin: 0,
  showEmptyLabel: null,
  titleContent: null,
  validationList: null,
  visualization: null,
  sourceType: null,
  dataSource: null,
  comparisonId: null,
  quantity: null,
  page: null,
  limitRow: null,
  sortingByColumn: null,
  labelList: null,
  replyToOriginalId: [],
  comparisonIdOnlineMedia: null,
  comparisonIdOfflineMedia: null,
  mediaList: null,
  searchType: null,
  clippingId: null,
  languageList: null
};

export const ECOMMERCE_SOURCES = [
  'lazada',
  'tokopedia',
  'shopee',
  'blibli'
  // 'tiktokshop',
  // 'olx'
] as const;
